var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.textClass},[(_vm.showIcon)?_c('font-awesome-icon',{class:_vm.editable ? 'clickable': '',attrs:{"icon":"clock","size":"1x"},on:{"click":_vm.onClickIcon}}):_vm._e(),_c('span',{attrs:{"id":"text"}},[_vm._v(" "+_vm._s(_vm.formatted))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }